module.exports = __webpack_public_path__ + "img/mt4-icon10.76aa340.png";